export const shortenPhone = (phone: string) => {
    const parsedDigits = phone.match(/^(\+?\d)\d+(\d{2})(\d{2})$/);

    return parsedDigits ? [parsedDigits[1], '∙∙∙ ∙∙∙', parsedDigits[2], parsedDigits[3]].join(' ') : phone;
};
